// @core/api/endpoints/workflow/remove_breakpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DebugSessionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Remove breakpoint
 * Removes a breakpoint from the debug session.
 */
export async function RemoveBreakpoint(
  session_id: string,
  breakpoint_id: string,
  options?: RequestOptions
): Promise<DebugSessionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/debug/:session_id/breakpoints/:breakpoint_id`;
  requestPath = requestPath.replace(':session_id', encodeURIComponent(session_id));
  requestPath = requestPath.replace(':breakpoint_id', encodeURIComponent(breakpoint_id));
  const requestOptions = options;
  return client.delete<DebugSessionResponse>(requestPath, requestOptions);
}
